<template>
    <b-modal size="sm" title="Generate Link" ok-only ok-variant="secondary" ok-title="Close"
             v-model="show" @close="$emit('handleModalClose')"
             @hidden="$emit('handleModalClose')">
        <div class="row">
            <K2Row class="col-lg-12">
                <el-select v-model="ddlClass" :placeholder="lang('Select Class')" class="pro-edt-select"
                           @change="ClassChange()" style="margin-right: 10px;" id="ddlClassID">
                    <el-option
                            v-for="item in ddlClassList"
                            :key="item.PK_Class_ID"
                            :label="item.CLS_ClassName + item.CLS_Batch "
                            :value="item.PK_Class_ID">
                    </el-option>
                </el-select>
                <el-select v-model="ddlStudent" :placeholder="lang('Select Student')" class="pro-edt-select"
                           style="margin-right: 10px;" id="ddlClassID">
                    <el-option
                            v-for="item in ddlStudentList"
                            :key="item.Student_ID"
                            :label="item.Student_Name"
                            :value="item.Student_ID">
                    </el-option>
                </el-select>
              <K2Button :disabled="!ddlStudent" @onclick="generateStudentLink" class="me-2">Generate Link</K2Button>
              <K2Button :disabled="!ddlStudent" @onclick="sendLinksToParents">Send Link to Parents</K2Button>
            </K2Row>

            <div class="col-lg-12 mt-3">
                Generated Parent Form URL:
                <K2CopyInput :value="generatedLink"/>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import DataSource from "../../../data/datasource";
    import { lang } from "../../../locale";
    import K2Button from "../../../uiComponents/k2Button/k2Button";
    import K2Row from "../../../uiComponents/k2Row/k2Row";
    import K2CopyInput from "../../../uiComponents/k2Input/K2CopyInput";

    export default {
        name: "WdfGenerateLinkModal",
        components: { K2CopyInput, K2Row, K2Button },
        props: ["modal", "handleModalClose"],
        data() {
            return {
                show: false,
                ddlClassList: [],
                ddlStudentList: [],
                ddlStudent: "",
                ddlClass: "",
                generatedLink: ""

            };
        },
        watch: {
            modal: function(value) {
                this.show = value === "generateStudentLinkModal";
            }
        },
        async created() {
            await this.bindClasses();
        },
        methods: {
            lang,
            async bindClasses() {
                try {
                    const response = await DataSource.shared.getFeedFilterClassList();
                    if (response) {
                        this.ddlClassList = response;
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async ClassChange() {
                await this.getClassStudentList();
                this.ddlStudent = "";
            },
            async getClassStudentList() {
                try {
                    if (this.ddlClass === "") {
                        this.$notify.error({
                            title: "Error",
                            message: "Please select Class..."
                        });
                    } else {

                        this.ddlStudentList = [];
                        const response = await DataSource.shared.LoadAttendanceListWithMode(this.ddlClass, "GroupClasName");
                        if (response) {
                            if (response.code === "2") {
                                console.log("get student by class no record");
                            } else if (response.code === "88") {
                                window.location.replace("/");
                            } else if (response.code === "99") {
                                console.log("get student by class error");
                            } else {
                                this.ddlStudentList = response.Table;
                            }
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            generateStudentLink() {
                let encryptStudentID = btoa(this.ddlStudent);
                let base;
                if (process.env.VUE_APP_ROOT_API.toUpperCase().includes("KWS-UAT")) {
                    base = "https://parent-uat.etonhouse.com";
                } else {
                    base = "https://parent.etonhouse.com";
                }
                this.generatedLink = base + "/Public/OnlineWithdrawalForm?studentID=" + encryptStudentID;
            },
          async sendLinksToParents(){
            try {
              const response = await DataSource.shared.sendWithdrawFormLinkToParent(this.ddlStudent);
              if (response) {
                this.$notify.success({
                  title: lang('Success'),
                  message: response?.message
                });
              }
            } catch (e) {
              console.log(e, "sendLinksToParents err");
            }
          }
        }
    };
</script>